import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { Box } from '@/shared/ui/box';
import { Image } from '@/shared/ui/image';
import { Button } from '@/shared/ui/form/button';
import {
  CasinoBonus,
  ChangeBonus,
  ContentBonus,
  InfoContainer,
  ListClose,
  InfoItem,
  BoxItems,
  InfoIcon,
} from './styles';
import {
  BodyTextMediumA,
  BodyTextMediumC,
  BodyTextRegularC,
  HeadingBoldH3,
} from '@/shared/ui/typography2';
import Switch from '@/shared/ui/switch/switch';
import { useScopedI18n } from '@locales/client';
import { useAuth } from '@/features/auth-managment/model/auth-context';
import { useWelcomeBonus } from '@/features/auth-managment/model/hooks/use-welcome-bonus';

const CasinoBonusBlock = ({ mobileLandscape, bgMod }) => {
  const { data } = useWelcomeBonus();
  const { formWelcomBanner, setFormWelcomBanner, viewInfo, setViewInfo } =
    useAuth();
  const t = useScopedI18n('bonus.card');

  const changeSwitch = () => {
    setFormWelcomBanner((res) => ({
      ...res,
      welcomeBonus: !res?.welcomeBonus,
    }));
  };

  // Анимация для появления/исчезновения
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.3,
        ease: 'easeOut',
      },
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: 'easeOut',
      },
    },
  };

  return (
    <>
      <CasinoBonus $bgMod={bgMod}>
        <ChangeBonus>
          <InfoIcon onClick={() => setViewInfo(true)}>
            <Image
              src="/images/icons/welcom_banner_signUp/Infornation.png"
              alt="Information"
            />
          </InfoIcon>

          {!mobileLandscape && (
            <Box>
              <Switch
                onCheckedChange={changeSwitch}
                checked={formWelcomBanner?.welcomeBonus}
              />
            </Box>
          )}
        </ChangeBonus>

        <ContentBonus>
          <Box>
            <BodyTextMediumA>{data?.name || '-'}</BodyTextMediumA>
            <HeadingBoldH3>{data?.percent}%</HeadingBoldH3>
          </Box>
          {mobileLandscape && (
            <Box>
              <Switch
                onCheckedChange={changeSwitch}
                checked={formWelcomBanner?.welcomeBonus}
              />
            </Box>
          )}
        </ContentBonus>
      </CasinoBonus>

      <AnimatePresence>
        {viewInfo &&
          (mobileLandscape ? (
            // Для мобильной ландшафтной ориентации
            <motion.div
              style={{
                height: '100%',
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <motion.div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  // justifyContent:'flex-end',
                  height: '100%',
                  justifyContent: 'space-between',
                }}
                variants={animationVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
              >
                <InfoContainer>
                  <BoxItems>
                    {data?.wager && (
                      <InfoItem $topRadius="true">
                        <BodyTextRegularC color="#AFAFAF">
                          {t('wager')}
                        </BodyTextRegularC>
                        <BodyTextMediumC>{`x${data?.wager}`}</BodyTextMediumC>
                      </InfoItem>
                    )}
                    {data?.maxWinMult && (
                      <InfoItem $bottomRadius="true">
                        <BodyTextRegularC color="#AFAFAF">
                          {t('max_win')}
                        </BodyTextRegularC>
                        <BodyTextMediumC>
                          {t('deposit_multiplier_template', {
                            value: data?.maxWinMult,
                          })}
                        </BodyTextMediumC>
                      </InfoItem>
                    )}
                  </BoxItems>
                </InfoContainer>

                <Button
                  type="button"
                  onClick={() => setViewInfo(false)}
                  fill
                  variant="danger"
                  style={{ width: '100%', maxHeight: '48px' }}
                >
                  <BodyTextMediumC>{t('button_close')} </BodyTextMediumC>
                </Button>
              </motion.div>
            </motion.div>
          ) : (
            <motion.div
              variants={animationVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <InfoContainer>
                <ListClose>
                  <Image
                    src="/images/icons/close-dialog.svg"
                    alt="close"
                    width={32}
                    height={32}
                    onClick={() => setViewInfo(false)}
                  />
                </ListClose>

                <BoxItems>
                  {data?.wager && (
                    <InfoItem $topRadius="true">
                      <BodyTextRegularC color="#AFAFAF">
                        {t('wager')}
                      </BodyTextRegularC>
                      <BodyTextMediumC>{`x${data?.wager}`}</BodyTextMediumC>
                    </InfoItem>
                  )}
                  {data?.maxWinMult && (
                    <InfoItem $bottomRadius="true">
                      <BodyTextRegularC color="#AFAFAF">
                        {t('max_win')}
                      </BodyTextRegularC>
                      <BodyTextMediumC>
                        {t('deposit_multiplier_template', {
                          value: data?.maxWinMult,
                        })}
                      </BodyTextMediumC>
                    </InfoItem>
                  )}
                </BoxItems>
              </InfoContainer>
            </motion.div>
          ))}
      </AnimatePresence>
    </>
  );
};

const CasinoBonusBlockWithBreakpointSlice = withBreakpointsSlice(
  CasinoBonusBlock,
  ({ mobileLandscape }) => ({ mobileLandscape })
);

export { CasinoBonusBlockWithBreakpointSlice as CasinoBonusBlock };
